import * as React from "react";
import {cs} from "@Common/react/chain-services";
import "./header.scss";

export const Header = ({icon, title, subTitle}) => cs(
    () => (
        <div className="header-6oi">
            <div className="icon" xd-qa-type="icon" xd-qa-name={title}>
                <img src={icon}/>
            </div>
            <div className="title" xd-qa-type="label" xd-qa-name={title}>
                {title}
            </div>
            <div className="sub-title" xd-qa-type="label" xd-qa-name={title+" Description"}>
                {subTitle}
            </div>

        </div>
    ),
);
